var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductsManufacturedGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_9274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_472_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_472_9274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_472_9274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_472_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5053 16.6069C23.5053 21.5225 19.7937 25.5708 15.02 26.1041L15.0207 26.1035C14.9907 26.1074 14.9608 26.1106 14.9302 26.1139C14.9263 26.1145 14.9217 26.1152 14.9178 26.1152C14.6437 26.1438 14.3656 26.1608 14.085 26.1634H14.0003C13.9827 26.164 13.9652 26.164 13.9476 26.164C13.9196 26.164 13.8916 26.1627 13.8636 26.1627C8.62432 26.1171 4.39046 21.8566 4.39046 16.6063C4.39046 12.7533 6.67083 9.43305 9.9553 7.92105C10.3037 7.76087 10.5225 7.40859 10.5225 7.02505V4.44254H10.5003C10.0328 4.44254 9.65381 4.06357 9.65381 3.59603V2.68245C9.65381 2.21491 10.0328 1.83594 10.5003 1.83594H17.4958C17.9633 1.83594 18.3423 2.21491 18.3423 2.68245V3.59603C18.3423 4.06357 17.9633 4.44254 17.4958 4.44254H17.4736V7.09147C17.4736 7.46654 17.6937 7.80384 18.0323 7.96403C21.2673 9.49556 23.5053 12.7898 23.5053 16.6069Z",
    stroke: "#E2E2E2",
    strokeWidth: 1.51667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9927 11.2261C19.7405 12.4199 20.9128 14.4045 20.9809 16.6821",
    stroke: "#E2E2E2",
    strokeWidth: 1.51667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.67 2.15"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_9274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsManufacturedGrey);
export default __webpack_public_path__ + "static/media/productsManufacturedGrey.d784b30d6052899000be5fe3d4e562ea.svg";
export { ForwardRef as ReactComponent };